import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  FDBodyText, FDBox, FDHeadlineText, FDList, FDListItem, FDSearchInput, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import scrollSelectorIntoView from 'Helpers/ScrollSelectorIntoView';
import { camelCase } from 'Helpers/Formats';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

const useStyles = buildUseStyles('SearchableFormLayout', (theme) => ({
  withBorder: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: theme.shape.borderRadius,
  },
}));

const Layout = ({ sections }) => {
  const { resource } = useMetaLayoutContext();
  const classes = useStyles();
  const [searchValue, setSearchValue] = useState('');

  // Handle Search Input change
  const handleSearchTemplates = (event) => {
    setSearchValue(event.target.value);
  };

  const fieldMatchesSearch = (field) => {
    const isFieldVisible = !resource.metaField(field).attr('hidden');
    return isFieldVisible && field.replace(/\s/g, '').toLowerCase().includes(searchValue.replace(/\s/g, '').toLowerCase());
  };

  const anyFieldMatchesSearch = (fields) => {
    for (const field of fields) {
      if (fieldMatchesSearch(field)) {
        return true;
      }
    }
    return false;
  };

  // Left side is the section menu. Right side is the content
  // Clicking on a menu item will scroll to the corresponding section
  // Left side contains a search bar that will hide fields that do not match the search query
  // TODO: For some reason, the fixedHeight prop in the modal layout configuration doesn't work. Doing this for now
  // so we can get the content to scroll independently of the sidebar
  return (
    <FDStack direction={'row'} spacing={6} height={'900px'} overflow={'hidden'}>
      <FDStack direction={'column'}>
        <FDSearchInput
          {...dataAttrs('field-search-bar-input')}
          placeholder={'Search'}
          value={searchValue}
          onChange={handleSearchTemplates}
          onSearch={handleSearchTemplates}
          fullWidth
        />
        <FDList>
          {sections.map((section) => (
            <FDListItem
              key={section.section}
              primaryText={section.section}
              onClick={() => {
                scrollSelectorIntoView(`#${camelCase(section.section)}`);
              }}
            />
          ))}
        </FDList>
      </FDStack>
      <FDBox width={'100%'} justifyContent={'center'} overflow={'auto'} height={'100%'}>
        <FDStack direction={'column'} spacing={4} overflow={'auto'} height={'100%'} paddingX={6}>
          {sections.map((section) => (
            anyFieldMatchesSearch(section.fields) ? (
              <div className={classes.withBorder}>
                <FDBox padding={4}>
                  <FDStack direction={'column'} spacing={4}>

                    <FDStack direction={'column'} spacing={1}>
                      <a key={section.section} id={`${camelCase(section.section)}`} href={`#${section.section}`}>
                        <FDHeadlineText value={section.section} color={'textSecondary'} />
                      </a>
                      {section.description && <FDBodyText value={section.description} /> }
                    </FDStack>

                    <FDStack direction={'column'} spacing={2}>
                      {section.fields.map((field) => (
                        searchValue && !fieldMatchesSearch(field) ? null : (
                          <MetaControlField attr={field} />
                        )
                      ))}
                    </FDStack>
                  </FDStack>
                </FDBox>
              </div>
            ) : null
          ))}
        </FDStack>
      </FDBox>
    </FDStack>
  );
};

Layout.defaultProps = {
};

Layout.propTypes = {
  sections: PropTypes.array.isRequired,
};

export default Layout;
